import { fade, makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	({ palette, spacing, transitions, breakpoints }) => ({
		root: {
			overflow: 'hidden',
			color: palette.secondary.contrastText,
		},
		button: ({ metaData }) => {
			const primaryColor = metaData.primary.metaValue || palette.primary.main
			const secondaryColor = metaData.backgroundDefault.metaValue || palette.secondary.main
			const linkColor = palette.calcContrastColor(primaryColor, secondaryColor)

			return {
				margin: spacing(0.4),
				width: spacing(4),
				height: spacing(4),
				minHeight: spacing(4),
				background: 'none',
				boxShadow: 'none',
				transition: transitions.create(['background-color']),
				color: linkColor,

				'&:hover': {
					backgroundColor: fade(linkColor, 0.2),
				},
			}
		},
		title: {
			marginBottom: 0,

			[breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) => {
						const mobileAlignment = metaData.mobileAlignment?.metaValue

						return mobileAlignment ? `${mobileAlignment} !important` : null
					},
				},
			},
		},
		iconsContainer: {
			display: 'flex',
			justifyContent: 'center',

			[breakpoints.down('sm')]: {
				justifyContent: ({ metaData }) => metaData.mobileAlignment?.contentAlignment(),
				margin: spacing(0, -0.4),
			},
		},
		icon: {
			fontSize: spacing(2),
			textAlign: 'center',
		},
	}),
	{ name: 'Content-Content7' },
)

export default useStyles
